export const environment = {
  production: false,
  apiUrl: 'https://api.dev.hello-menu.com',
  stage: 'dev'
};

